import { c as _c } from "react/compiler-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { isEmpty } from 'lodash';
import qs from 'query-string';
import { getItemFromStorage, setItemInStorage } from 'commons/localStorage';
import scrollTo from 'commons/scrollTo';
import isClient from 'commons/isClient';
import stringToClassName from 'commons/stringToClassName';
import useSetCSSVariables from 'hooks/useSetCSSVariables';
import CustomerQuote from 'components/consumer/CustomerQuote';
import FabricAdditionalAttributes from 'components/consumer/FabricAdditionalAttributes';
import GridWithSidebarPhotoModal from 'components/consumer/GridWithSidebarPhotoModal';
import HotSpotWrapper from 'components/consumer/hotspot-wrapper';
import ImageSliderStandard from 'components/consumer/image-slider-standard';
import MixedGrid from 'components/consumer/mixed-grid';
import notificationBannerHelper from 'components/consumer/NotificationBanner/utils';
import PushAcrossSidebar from 'components/consumer/PushAcrossSidebar';
import TabPanel from 'components/consumer/TabPanel';
import CtaLink from 'components/essentials/Cta/CtaLink';
import JBImage from 'components/essentials/JBImage';
import IconClose from 'components/icons/iconClose';
import IconHeart2 from 'components/icons/iconHeart2';
import IconHeart4 from 'components/icons/iconHeart4';
import useGetCSSVariables from 'hooks/useGetCSSVariables';
import useScreen from 'hooks/useScreen';
import useIsTouchDevice from 'hooks/useIsTouchDevice';
import useStaticProductCardData from 'hooks/useStaticProductCardData';
import HotspotProductCard from '../hotspot-wrapper/HotspotProductCard';
import { getReactTooltipValues } from '../hotspot-wrapper/utils';
import FabricGallery from './components/FabricGallery';
import { withState } from './withState';
import ProductsGridStatic from '../products-grid/ProductsGridStatic';
const ZOOM_IMG_PROPS = {
  w: 1800,
  h: 915
};
const JB_IMG_PROPS = {
  height: 300,
  width: 590
};
const DEFAULT_TABS_CONFIG = {
  all: true,
  products: true,
  customerPhotos: true
};
const DEFAULT_IMG_PROPS = {
  auto: 'format,compress',
  fit: 'fill',
  crop: 'entropy',
  h: 430,
  w: 875
};
const DOUBLE_PRESS_DELAY = 300;
const HEADER_HEIGHT = 60;
const GridItemImageWrapper = t0 => {
  const $ = _c(3);
  const {
    wrap: t1,
    children
  } = t0;
  const wrap = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== children || $[1] !== wrap) {
    t2 = wrap ? <div className="max-[767px]:h-[80vw] max-[767px]:min-w-[calc(80vw_+_1rem)] max-[767px]:pr-4 [&_img]:max-[767px]:h-[80vw] [&_img]:max-[767px]:w-[80vw]">{children}</div> : children;
    $[0] = children;
    $[1] = wrap;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
GridItemImageWrapper.propTypes = {
  children: PropTypes.node,
  wrap: PropTypes.bool
};
const HotspotTooltipProductCard = t0 => {
  const $ = _c(11);
  const {
    productData
  } = t0;
  if (!productData) {
    return null;
  }
  let productDataSplits;
  let productId;
  let t1;
  let t2;
  if ($[0] !== productData) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      productDataSplits = productData.split("?");
      productId = parseInt(productDataSplits[0], 10);
      if (!productId) {
        t2 = null;
        break bb0;
      }
      t1 = qs.parse(productDataSplits[1] || "");
    }
    $[0] = productData;
    $[1] = productDataSplits;
    $[2] = productId;
    $[3] = t1;
    $[4] = t2;
  } else {
    productDataSplits = $[1];
    productId = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const productConfig = t1;
  const t3 = `hotspot-tooltip-${productId}-${productDataSplits[1] || ""}`;
  let t4;
  if ($[5] !== productConfig || $[6] !== productId) {
    t4 = <HotspotProductCard productId={productId} productConfig={productConfig} />;
    $[5] = productConfig;
    $[6] = productId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="w-[150px]" key={t3}>{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
HotspotTooltipProductCard.propTypes = {
  productData: PropTypes.string
};
const DEFAULT_HOTSPOT_DATA_ARRAY = [];
const createFallbackSlide = src => ({
  url: src,
  isVideo: false,
  imgProps: DEFAULT_IMG_PROPS,
  zoomUrl: src,
  videoProps: {},
  className: '',
  zoomImgProps: ZOOM_IMG_PROPS,
  jbImgProps: JB_IMG_PROPS
});
const GridWithSidebar = props => {
  const {
    isFabricGalleryEnabled = false,
    variant,
    tabsConfig = DEFAULT_TABS_CONFIG,
    naturalHeightImages = false,
    loading = false,
    gridItemType,
    mobileItemsPerRow,
    desktopFilterSize,
    updateContentScrollOnChange,
    state: {
      selectedGridItem,
      selectedGridItemCustomProps: customProps,
      modalValue,
      photosList,
      reviewsList,
      allDataList,
      productIdsList: productIds,
      currentSelection,
      hasLoadMoreReviews,
      hoveredValue,
      loadingData,
      loadingMore
    },
    actions,
    isFavorited,
    toggleFavClick,
    renderGrid,
    location
  } = props;
  const stickyRef = useRef(null);
  const [hotspotData, setHotspotData] = useState(DEFAULT_HOTSPOT_DATA_ARRAY);
  const lastTapRef = useRef(null);
  const showBannerNotificationRef = useRef(null);
  const isTouchDevice = useIsTouchDevice();
  const {
    isMobile,
    isMobileOrTablet,
    isDesktop
  } = useScreen();
  const isTablet = isMobileOrTablet && !isMobile;
  const favProps = useMemo(() => {
    if (isClient() && gridItemType === 'fabric' && selectedGridItem?.option) {
      return {
        fabricId: selectedGridItem.option.id,
        fabricName: selectedGridItem.footerTitle.name,
        fabricColor: selectedGridItem.option.color,
        location: window?.location.pathname.toLowerCase().includes('swatches') ? 'Swatches' : null
      };
    }
    return {};
  }, [gridItemType, selectedGridItem?.option, selectedGridItem?.footerTitle]);
  const showNotificationBannerFn = useCallback(() => {
    notificationBannerHelper.showMsg('FabricFavoritedBanner', {
      fabricName: selectedGridItem.footerTitle.name,
      isFavorited,
      isUserLoggedIn: customProps.isUserLoggedIn,
      favNum: !customProps.isUserLoggedIn ? customProps.numOfFavFabrics : 0
    });
  }, [customProps?.isUserLoggedIn, customProps?.numOfFavFabrics, isFavorited, selectedGridItem?.footerTitle?.name]);
  useEffect(() => {
    if (gridItemType !== 'fabric' || !showBannerNotificationRef.current) {
      return;
    }
    showNotificationBannerFn();
    showBannerNotificationRef.current = null;
  }, [customProps.isUserLoggedIn, gridItemType, showNotificationBannerFn]);
  const images = useMemo(() => {
    if (!isFabricGalleryEnabled || isEmpty(selectedGridItem) || isEmpty(customProps?.images)) {
      return [];
    }
    return customProps.images.map(image => ({
      url: image,
      isVideo: false,
      imgProps: DEFAULT_IMG_PROPS,
      zoomUrl: image,
      videoProps: {},
      className: '',
      zoomImgProps: ZOOM_IMG_PROPS,
      jbImgProps: JB_IMG_PROPS
    }));
  }, [customProps?.images, isFabricGalleryEnabled, selectedGridItem]);
  const isSidebarOpen = !!selectedGridItem;
  const {
    '--push-across-sidebar-open-width': pushAcrossSidebarOpenWidth = '1px'
  } = useGetCSSVariables(['--push-across-sidebar-open-width']);
  const pushAcrossSidebarOpenWidthNum = useMemo(() => pushAcrossSidebarOpenWidth ? parseInt(pushAcrossSidebarOpenWidth.replace('px', ''), 10) : 1, [pushAcrossSidebarOpenWidth]);
  const openMultiplier = isSidebarOpen ? 1 : 0;
  const contentRightMargin = useMemo(() => {
    const openRightMargin = 32 + openMultiplier * pushAcrossSidebarOpenWidthNum;
    const closedRightMargin = isClient() ? window.innerWidth / 100 * 3.333 : 0;
    return `${Math.max(openRightMargin, closedRightMargin)}px`;
  }, [openMultiplier, pushAcrossSidebarOpenWidthNum]);
  const sidebarCurrentWidth = useMemo(() => `${openMultiplier * pushAcrossSidebarOpenWidthNum}px`, [openMultiplier, pushAcrossSidebarOpenWidthNum]);
  useSetCSSVariables({
    '--push-across-sidebar-content-right-margin': contentRightMargin,
    '--push-across-sidebar-current-width': sidebarCurrentWidth
  });
  const updateSelectedGridItem = useCallback(gridItem => {
    if (selectedGridItem === gridItem) {
      return;
    }
    actions.updateSelectedGridItem(gridItem);
    if (stickyRef.current) {
      stickyRef.current.scrollTo(0, 0);
    }
    if (stickyRef.current && !isMobile && isClient() && updateContentScrollOnChange // this props is handled from parent to scroll into
    ) {
      if (stickyRef.current.getBoundingClientRect().top === 0) {
        setItemInStorage('previousScrollPosition', window.scrollY);
      }
      // When sidebar is closed then we get the top value of it then apply scroll to that scroll position
      const stickyVerticalPosition = stickyRef.current.getBoundingClientRect().top > 0 ? getItemFromStorage('previousScrollPosition') : stickyRef.current.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
      scrollTo(0, stickyVerticalPosition);
    }
  }, [actions, isMobile, selectedGridItem, updateContentScrollOnChange]);
  const gridComponent = useMemo(() => renderGrid?.({
    selectedGridItem,
    showOnTop: isSidebarOpen,
    updateSelectedGridItem
  }), [renderGrid, selectedGridItem, isSidebarOpen, updateSelectedGridItem]);
  const headerImgProps = useMemo(() => selectedGridItem && selectedGridItem.imageProps || customProps.imageProps, [selectedGridItem, customProps.imageProps]);
  const isMaterialItemType = useMemo(() => customProps?.selectedItemType === 'Fabric' || customProps?.selectedItemType === 'Leather', [customProps?.selectedItemType]);
  const hasItemMaterialList = useMemo(() => customProps?.selectedItemMaterialList?.length && !customProps?.selectedItemMaterialList?.includes(null), [customProps?.selectedItemMaterialList]);
  const upholsteryName = useMemo(() => {
    if (isMaterialItemType) {
      return [customProps.selectedItemMaterial];
    }
    if (hasItemMaterialList) {
      return customProps.selectedItemMaterialList;
    }
    return undefined;
  }, [isMaterialItemType, hasItemMaterialList, customProps.selectedItemMaterial, customProps.selectedItemMaterialList]);
  const {
    loading: allStaticProductDataLoading,
    products: allStaticProductData
  } = useStaticProductCardData({
    productIds,
    upholsteryLabelFilters: upholsteryName
  });
  const isWoodStainSelected = useMemo(() => customProps.selectedItemType === 'Wood Stain', [customProps.selectedItemType]);
  const isPushAcrossFullHeight = isWoodStainSelected;
  const {
    selectedItemTier,
    selectedItemGroupMaterial,
    selectedItemGroupCleaningCode,
    isPetAndKidFriendly,
    isSustainable,
    isGreenguardGold = false
  } = customProps;
  const tabs = useMemo(() => {
    const tabsArray = [];
    if (!selectedGridItem || !tabsConfig) {
      return tabsArray;
    }
    if (tabsConfig.all) {
      const label = tabsConfig.allTitle || 'All';
      const id = stringToClassName(label);
      tabsArray.push({
        label,
        id,
        contentId: `${id}-content`,
        content: <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(200px,1fr))] mt-2 w-full">
            {reviewsList.length && photosList.length ? <MixedGrid allData={allDataList} gridWithReviews={gridItemType === 'fabric' && reviewsList.length} hoveredValue={hoveredValue} isMixedGridTab keyId="All MG" layout="minimal" loading={loadingData} loadingMore={loadingMore} loadMore={actions.loadMore} maxCardsCount={12} onHoverHandler={actions.toggleReviewOnHover} optionState="allOpts" toggleModalView={actions.toggleModalView} allStaticProductData={allStaticProductData} /> : <ProductsGridStatic columnsOnDesktop="2" columnsOnMobile="1" layout="minimal-with-attributes" listName="SideBar" loading={allStaticProductDataLoading} maxCardsCount={2} productsData={allStaticProductData} />}
          </div>
      });
    }
    const showHotspotProducts = hotspotData && hotspotData.length > 0 && !location.pathname.includes('/customer-photos');
    if (showHotspotProducts) {
      const label_0 = tabsConfig.productsTitle || 'Products';
      const id_0 = stringToClassName(label_0);
      tabsArray.push({
        label: label_0,
        id: id_0,
        contentId: `${id_0}-content`,
        content: <div className="mt-5">
            <MixedGrid allData={hotspotData.map(hotspot => ({
            id: hotspot.product_id,
            card_type: 'productId'
          }))} keyId="Products MG" layout="minimal" loading={loading} loadingMore={false} />
          </div>
      });
    } else if (tabsConfig.products) {
      const productsTitle = tabsConfig.productsTitle || 'Products';
      const id_1 = stringToClassName(productsTitle);
      tabsArray.push({
        label: productsTitle,
        id: id_1,
        contentId: `${id_1}-content`,
        content: <div className="mt-5">
            <ProductsGridStatic columnsOnDesktop="2" columnsOnMobile="1" layout="minimal-with-attributes" listName="SideBar" loading={allStaticProductDataLoading} maxCardsCount={2} productsData={allStaticProductData} />
          </div>
      });
    }
    if (tabsConfig.customerPhotos) {
      const label_1 = tabsConfig.customerPhotosTitle || 'Customer Photos';
      const id_2 = stringToClassName(label_1);
      tabsArray.push({
        label: label_1,
        id: id_2,
        contentId: `${id_2}-content`,
        tabClass: 'customer-photos-tab-label',
        content: <div className="grid gap-4 grid-cols-[repeat(auto-fit,minmax(200px,1fr))] mt-2 w-full">
            <MixedGrid allData={photosList} hoveredValue={hoveredValue} isMixedGridTab keyId="Customer Photos MG" loading={loadingData} loadingMore={loadingMore} loadMore={actions.loadMore} maxCardsCount={6} onHoverHandler={actions.toggleReviewOnHover} showProductOptions toggleModalView={actions.toggleModalView} />
          </div>
      });
    }
    if (tabsConfig.fabricReviews) {
      const label_2 = tabsConfig.fabricReviewsTitle || 'Fabric Reviews';
      const id_3 = stringToClassName(label_2);
      tabsArray.push({
        label: label_2,
        id: id_3,
        contentId: `${id_3}-content`,
        tabClass: 'fabric-reviews-tab-label',
        content: <div className="m-4">
            <MixedGrid maxCardsCount={6} allData={reviewsList} loadMore={hasLoadMoreReviews ? actions.loadMore : null} loadingMore={loadingMore} loading={loadingData} gridWithOneCol keyId="Reviews MG" />
          </div>
      });
    }
    return tabsArray;
  }, [selectedGridItem, tabsConfig, reviewsList, photosList, allDataList, allStaticProductData, allStaticProductDataLoading, gridItemType, hoveredValue, loadingData, loadingMore, actions, hotspotData, location, loading, hasLoadMoreReviews]);
  const fallbackSlideArray = useMemo(() => {
    if (headerImgProps?.src) {
      return [createFallbackSlide(headerImgProps.src)];
    }
    return [];
  }, [headerImgProps?.src]);
  const headerImage = useMemo(() => {
    if (!selectedGridItem) return null;
    return <>
        {headerImgProps && <HotSpotWrapper dontFadeTagIcon size={isMobile ? 'small' : 'big'} root={isMobile ? 'local' : 'global'} showTooltip src={headerImgProps.src} setHotspotData={setHotspotData}>
            <div className="GridItemSidebar__image--container" onDoubleClick={() => {
          if (gridItemType !== 'fabric' || isTouchDevice || isFabricGalleryEnabled) {
            return;
          }
          toggleFavClick(favProps);
          if (!isFavorited) {
            showBannerNotificationRef.current = true;
          }
        }} onClick={() => {
          if (gridItemType !== 'fabric' || !isTouchDevice || isFabricGalleryEnabled) {
            return;
          }
          const now = Date.now();
          if (lastTapRef.current && now - lastTapRef.current < DOUBLE_PRESS_DELAY) {
            toggleFavClick(favProps);
            if (!isFavorited) {
              showBannerNotificationRef.current = true;
            }
          } else {
            lastTapRef.current = now;
          }
        }}>
              {gridItemType === 'fabric' && isFabricGalleryEnabled && headerImgProps.src ? <FabricGallery isMobileMaterialSwatches={mobileItemsPerRow !== 0} slides={images?.length ? images : fallbackSlideArray} mobileItemsPerRow={mobileItemsPerRow} bottomRightSide={gridItemType === 'fabric' ? <button type="button" className={classNames('![background:none] !border-0 !rounded-full !flex !min-h-[34px] !min-w-[34px] !mr-0', 'focus:!outline-0', 'focus-visible:outline-offset-8', 'hover:cursor-pointer', '[&_svg]:!h-8 [&_svg]:!w-8', '[&_svg_path]:!fill-white', '[&:hover_svg_path]:stroke-[#107c8c]', {
            '[&:hover_svg_path]:!fill-brand': !isFavorited
          })} onClick={e => {
            e.stopPropagation();
            toggleFavClick(favProps);
            if (!isFavorited) {
              showBannerNotificationRef.current = true;
            }
          }}>
                        {isFavorited ? <IconHeart2 fill="white" color="white" /> : <IconHeart4 />}
                      </button> : null} /> : <JBImage {...headerImgProps} sizes="50vh" className={classNames('relative h-[45vh] object-cover object-center w-full max-[767px]:portrait:h-[100vw]', {
            'h-auto max-h-[82.5vh] max-[767px]:portrait:h-auto': !!naturalHeightImages,
            'GridItemSidebar__image--FabricGallery': isFabricGalleryEnabled
          })} />}
            </div>
          </HotSpotWrapper>}

        {selectedGridItem.images && selectedGridItem.images.length > 0 && <ImageSliderStandard arrowPosition="inset" config={{
        children: selectedGridItem.images.map(img => <GridItemImageWrapper wrap={isMobile && gridItemType === 'collection'}>
                  <JBImage src={img.url} fallbackSrc={img.url} alt="" height={400} className="2xl:!hidden" />
                  <JBImage src={img.url} fallbackSrc={img.url} alt="" height={600} className="!hidden 2xl:!block" />
                </GridItemImageWrapper>),
        sliderConfig: {
          navType: isMobile ? 'Dots' : 'Button',
          visibleSlides: 1,
          infinite: true,
          deviceOverride: !!isDesktop
        },
        variation: {
          value: 'Component'
        }
      }} fullWidth />}
      </>;
  }, [selectedGridItem, headerImgProps, isMobile, gridItemType, isTouchDevice, isFabricGalleryEnabled, toggleFavClick, favProps, isFavorited, images, mobileItemsPerRow, naturalHeightImages, isDesktop, fallbackSlideArray]);
  return <div className={classNames('relative [&_.infinite-scroll-component]:m-[0-1rem] [&_.infinite-scroll-component>div]:w-full max-[767px]:bg-white max-[767px]:w-screen', {
    'max-[767px]:z-[1001]': isSidebarOpen,
    'min-h-screen': selectedGridItem,
    '!w-full': gridItemType === 'fabric' || variant === 'InspirationPage'
  })}>
      <div className={classNames('relative min-h-[calc(100vh - 60px)] [&_.slider]:!p-0 [&_.slider-control-centerleft]:!left-8 [&_.slider-control-centerright]:!right-8 max-md:grid-cols-[repeat(auto-fill,minmax(30%,1fr))]', {
      'min-h-[auto]': gridItemType === 'fabric',
      'max-md:!grid-cols-[repeat(auto-fill,minmax(95%,1fr))]': mobileItemsPerRow === 1,
      'max-md:!grid-cols-[repeat(auto-fill,minmax(45%,1fr))]': mobileItemsPerRow === 2
    })}>
        {modalValue.isClicked && <GridWithSidebarPhotoModal photosList={photosList} photo={modalValue.modalFor} index={modalValue.photoIndex} isModalOpen={modalValue.isClicked} toggleModal={actions.toggleModalView} loadMore={actions.loadMore} loadingMore={loadingMore} loading={loadingData} />}

        <div className={classNames('my-0 ml-auto mr-0 md:mr-[var(--push-across-sidebar-content-right-margin)]', {
        // restrict margin to prevent mason layout re-calculation
        'md:!mr-[3.333vw]': !isSidebarOpen
      })}>
          {gridComponent}
        </div>
        <PushAcrossSidebar desktopFilterSize={desktopFilterSize} isFullHeight={isPushAcrossFullHeight} isMaterialSwatch={isMobile && mobileItemsPerRow !== 0 || isTablet} isOpen={isSidebarOpen} mobileContentNoPadding mobileHideHeader mobileOnClose={() => {
        updateSelectedGridItem(null);
      }} mobileTitle={selectedGridItem ? <div className="flex m-auto items-center justify-center">
                <span className="text-base font-bold text-gray">
                  {customProps.selectedItemNameMobile || customProps.selectedItemName}
                </span>
              </div> : ''} stickyRef={stickyRef} mobileClassName={classNames('GridWithSidebar__MobileModal', {
        'GridWithSidebar__MobileModal--fabric': gridItemType === 'fabric',
        'GridWithSidebar__MobileModal--collection': gridItemType === 'collection',
        'GridWithSidebar__MobileModal--customer-photo': gridItemType === 'customer-photo'
      })} mobileContentUnderHeader={<>
              {!isDesktop && <ReactTooltip
        // Note: The hotspot-tooltip-wrapper class is required for
        // the HotspotRenderer component to target this correctly
        // (since it is a third party we cannot use a data attribute
        // here)
        className="hotspot-tooltip-wrapper p-0 !absolute !opacity-100 [transition:all_.3s_ease-in-out] !text-gray-light8 !bg-gray-light8 hover:!text-[#eaeaeb] hover:![background:#eaeaeb]" type="light" effect="solid" event="none" clickable place="bottom" overridePosition={({
          left,
          top
        }) => {
          const root = getReactTooltipValues('root');
          const rootRef = root === 'local' ? getReactTooltipValues('rootRef') : null;
          if (!rootRef) {
            return {
              left,
              top
            };
          }
          const position = rootRef.getBoundingClientRect();
          return {
            left: left < 0 ? 0 : left - position.left,
            top
          };
        }} getContent={productData => <HotspotTooltipProductCard productData={productData} />} />}
              {headerImage}
            </>} mobileHeaderRightClassName={`!opacity-100 mr-[calc(12%_-_2px)] ${images === undefined || images?.length <= 1 ? '!mr-[calc(5%_-_2px)]' : ''}`} mobileHeaderRight={<button type="button" className={classNames('z-[1] items-center !bg-white border border-solid border-gray-light6 rounded-[48px] cursor-pointer flex h-10 justify-center w-10 hover:border-brand focus-visible:outline-offset-[-2px] [&_svg_path]:fill-gray', {
        'ml-[calc(9%_-_2px)]': isFabricGalleryEnabled
      })} onClick={() => {
        updateSelectedGridItem(null);
      }}>
              <IconClose />
            </button>} isPhotoModalOpen={modalValue.isClicked} variant={gridItemType === 'fabric' ? 'fabric-grid' : undefined}>
          {!isMobile && !isTablet && <div className={classNames('flex items-center top-8 h-0 absolute left-4 right-0 z-[1] mr-[calc(10%_+_1rem_-_2px)] justify-end', {
          '!mr-[3%]': images === undefined || images?.length <= 1
        })}>
              <button type="button" className={classNames('z-[1] items-center !bg-white border border-solid border-gray-light6 rounded-[48px] cursor-pointer flex h-10 justify-center w-10 hover:border-brand focus-visible:outline-offset-[-2px] [&_svg_path]:fill-gray', {
            'ml-[calc(9%_-_2px)]': isFabricGalleryEnabled
          })} onClick={() => {
            updateSelectedGridItem(null);
          }}>
                <IconClose />
              </button>
            </div>}
          {!!selectedGridItem && <>
              {!isMobile && !isTablet && headerImage}

              <div className={classNames('px-0 py-10 md:pt-10 md:px-8 md:pb-8', {
            'max-[767px]:!pt-5': variant === 'InspirationPage'
          })}>
                <div className="max-lg:px-5">
                  <div className="items-center flex flex-row flex-wrap">
                    <h2 className={classNames('text-2xl font-bold text-gray mb-3', {
                  'max-[767px]:mb-2': variant === 'InspirationPage'
                })}>
                      {customProps.selectedItemName}
                    </h2>
                  </div>
                  <div className="w-full">
                    <FabricAdditionalAttributes selectedItemGroupMaterial={selectedItemGroupMaterial} selectedItemGroupCleaningCode={selectedItemGroupCleaningCode} isPetAndKidFriendly={isPetAndKidFriendly} isSustainable={isSustainable} isGreenguardGold={isGreenguardGold} selectedItemTier={selectedItemTier} />
                  </div>

                  {customProps.selectedItemDescription && <CustomerQuote size="sm" showQuoteMark={!!customProps.showDescriptionQuoteMark} variant={variant}>
                      {customProps.selectedItemDescription}
                    </CustomerQuote>}

                  <div className="flex flex-row max-[767px]:items-start max-[767px]:flex-col [&_>_*]:max-[767px]:mt-[1.2rem] [&>:first-child]:max-[767px]:mt-0">
                    {customProps.shopThisTextLink && !isWoodStainSelected && <CtaLink onClick={customProps.shopThisTextClick} to={customProps.shopThisTextLink} styling="solid-button" color="brand">
                        {customProps.shopThisText}
                      </CtaLink>}

                    {customProps.customerPhotosUrl && !isWoodStainSelected && <CtaLink to={customProps.customerPhotosUrl} styling="link" color="brand" noLinkPadding={!!isMobile}>
                        View Customer Photos
                      </CtaLink>}
                  </div>
                </div>

                {!!tabs.length && !isWoodStainSelected && (tabs.length === 1 ? <div className="max-[767px]:p-4">
                      <div className="text-lg text-gray font-bold mb-2">
                        {tabs[0].label}
                      </div>

                      <div>{tabs[0].content}</div>
                    </div> : <div className="mt-10 md:mt-[75px]">
                      <TabPanel aria-label="Products and Customer Photos" items={tabs} selectedTab={currentSelection} onSelectTab={id_4 => {
                actions.updateResultSelection(id_4);
              }} />
                    </div>)}
              </div>
            </>}
        </PushAcrossSidebar>
      </div>
    </div>;
};
GridWithSidebar.propTypes = {
  actions: PropTypes.shape({
    loadMore: PropTypes.func,
    loadMoreProducts: PropTypes.func,
    toggleModalView: PropTypes.func,
    toggleReviewOnHover: PropTypes.func,
    updateResultSelection: PropTypes.func,
    updateSelectedGridItem: PropTypes.func
  }),
  all: PropTypes.bool,
  customerPhotos: PropTypes.bool,
  desktopFilterSize: PropTypes.number,
  gridItemType: PropTypes.oneOf(['fabric', 'collection', 'customer-photo']),
  history: PropTypes.shape({
    goBack: PropTypes.func
  }),
  isFabricGalleryEnabled: PropTypes.bool,
  isFavorited: PropTypes.bool,
  loading: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    includes: PropTypes.string
  }),
  mobileItemsPerRow: PropTypes.number,
  naturalHeightImages: PropTypes.bool,
  products: PropTypes.bool,
  renderGrid: PropTypes.func,
  state: PropTypes.shape({
    allDataList: PropTypes.arrayOf(PropTypes.shape({
      card_type: PropTypes.string,
      id: PropTypes.string,
      photo_id: PropTypes.string
    })),
    currentSelection: PropTypes.string,
    hasLoadMoreReviews: PropTypes.bool,
    hoveredValue: PropTypes.string,
    loadingData: PropTypes.bool,
    loadingMore: PropTypes.bool,
    modalValue: PropTypes.shape({
      isClicked: PropTypes.bool,
      modalFor: PropTypes.string,
      photoIndex: PropTypes.number
    }),
    photosList: PropTypes.arrayOf({
      card_type: PropTypes.string,
      id: PropTypes.string,
      photo_id: PropTypes.string
    }),
    productIdsList: PropTypes.shape({
      length: PropTypes.number
    }),
    reviewsList: PropTypes.shape({
      length: PropTypes.number
    }),
    selectedGridItem: PropTypes.shape({
      footerTitle: PropTypes.shape({
        name: PropTypes.string
      }),
      imageProps: PropTypes.object,
      images: PropTypes.shape({
        length: PropTypes.number,
        map: PropTypes.func
      }),
      option: PropTypes.shape({
        color: PropTypes.string,
        id: PropTypes.number
      }),
      products: PropTypes.shape({
        forEach: PropTypes.func
      })
    }),
    selectedGridItemCustomProps: PropTypes.shape({
      customerPhotosUrl: PropTypes.string,
      // eslint-disable-next-line react/forbid-prop-types
      imageProps: PropTypes.any,
      images: PropTypes.shape({
        map: PropTypes.func
      }),
      isPetAndKidFriendly: PropTypes.bool,
      isSustainable: PropTypes.bool,
      isGreenguardGold: PropTypes.bool,
      isUserLoggedIn: PropTypes.bool,
      numOfFavFabrics: PropTypes.number,
      onProductCardClick: PropTypes.func,
      selectedItemDescription: PropTypes.string,
      selectedItemGroupCleaningCode: PropTypes.string,
      selectedItemGroupMaterial: PropTypes.string,
      selectedItemMaterial: PropTypes.string,
      selectedItemMaterialList: PropTypes.arrayOf(PropTypes.string),
      selectedItemName: PropTypes.string,
      selectedItemNameMobile: PropTypes.string,
      selectedItemTier: PropTypes.string,
      selectedItemType: PropTypes.string,
      shopThisText: PropTypes.string,
      shopThisTextClick: PropTypes.func,
      shopThisTextLink: PropTypes.string,
      showDescriptionQuoteMark: PropTypes.bool
    })
  }),
  tabsConfig: PropTypes.shape({
    all: PropTypes.bool,
    allTitle: PropTypes.string,
    customerPhotos: PropTypes.bool,
    customerPhotosTitle: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    fabricReviews: PropTypes.any,
    fabricReviewsTitle: PropTypes.string,
    products: PropTypes.bool,
    productsHideLoadMore: PropTypes.bool,
    productsTitle: PropTypes.string
  }),
  toggleFavClick: PropTypes.func,
  updateContentScrollOnChange: PropTypes.func,
  variant: PropTypes.oneOf(['InspirationPage'])
};
export default withState(GridWithSidebar);